import { getFirestore } from "firebase/firestore"
import { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useHistory } from "react-router-dom"
import { updateGameStateFromFirestore } from "../../services/gameService"

const Loading = () => {
  const db = getFirestore()
  const game = useSelector(state => state.game)
  const dispatch = useDispatch()
  const history = useHistory()

  useEffect(() => {
    setTimeout(async () => {
      await updateGameStateFromFirestore(db, game.id, dispatch)
      history.push('/room')
    }, 1000)
  }, [db, dispatch, game.id, history])

  return (
    <div>loading</div>
  )
}

export default Loading